export default __webpack_public_path__ + "static/media/partner7.60eac62b.jpg";